<template>
  <v-app>
    <v-content class="fill-height">
        <router-view ></router-view>
    </v-content>
    <QrCodeReader :visibility="isDialogOpened" @hideDialog="hideDialog"/>
    <snackbar/>
  </v-app>
</template>

<script>
import QrCodeReader from '@/components/QrCode'

export default {
  components: {
    QrCodeReader
  },

  methods: {
    hideDialog () {
      this.$router.push('/solicitar_saida')
    }
  },

  computed: {
    isDialogOpened () {
      const { path } = this.$route
      return path.includes('qr')
    }
  }
}
</script>
